export default "__VITE_ASSET__DmA9nax4__"